import React from 'react';
import { motion } from 'framer-motion';

const AnimatedGradient = ({ data = {} }) => {
  const colors = data.colors || ['#667eea', '#764ba2', '#f093fb', '#4facfe'];

  return (
    <div className="relative h-full w-full overflow-hidden">
      <motion.div
        className="absolute inset-0"
        animate={{
          background: [
            `linear-gradient(135deg, ${colors[0]} 0%, ${colors[1]} 100%)`,
            `linear-gradient(225deg, ${colors[1]} 0%, ${colors[2]} 100%)`,
            `linear-gradient(315deg, ${colors[2]} 0%, ${colors[3]} 100%)`,
            `linear-gradient(45deg, ${colors[3]} 0%, ${colors[0]} 100%)`,
            `linear-gradient(135deg, ${colors[0]} 0%, ${colors[1]} 100%)`,
          ],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
      
      <div className="relative z-10 flex items-center justify-center h-full">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="text-center text-white px-8"
        >
          <h1 className="text-5xl font-bold mb-4 drop-shadow-lg">
            {data.title || 'Hero Section'}
          </h1>
          <p className="text-xl opacity-90 drop-shadow-md">
            {data.subtitle || 'With animated gradient background'}
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AnimatedGradient;

